//注册登录忘记密码
export default {
  //登录
  login: (resolve) => {
    require.ensure([], () => {
      resolve(require('@/views/login-reg/login.vue'));
    }, '/modules/login-reg/login');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/login-reg.js